import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { LoaderService } from './loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private _requests: HttpRequest<any>[] = [];

  constructor(private _loaderService: LoaderService) {}

  removeRequest(req: HttpRequest<any>): void {
    const i = this._requests.indexOf(req);

    if (i >= 0) {
      this._requests.splice(i, 1);
    }

    this._loaderService.isLoading.next(this._requests.length > 0);
  }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler,
  ): Observable<HttpEvent<any>> {
    this._requests.push(req);

    this._loaderService.isLoading.next(true);
    return new Observable((observer) => {
      const subscription = next.handle(req).subscribe(
        (event) => {
          // TODO ~get hardik assist to return an object on 201 as well #library bug
          if (event instanceof HttpResponse) {
            this.removeRequest(req);
            observer.next(event);
          }
        },
        (err) => {
          this.removeRequest(req);
          observer.error(err);
        },
        (): void => {
          this.removeRequest(req);
          observer.complete();
        },
      );

      // remove request from queue when cancelled
      return (): void => {
        this.removeRequest(req);
        subscription.unsubscribe();
      };
    });
  }
}
